import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useFormatMessage } from '@artemis/integrations/contentful/utils';
import { getIsEmbedded } from '@artemis/store/embed/selectors';

const Link = styled.a`
  text-decoration: none;
  color: ${props => props.theme.palette.primary};
  font-weight: ${props => props.theme.typography.fontWeightMedium};
`;

const ContactLink = ({ children }) => {
  const contactUrl = useFormatMessage({ entry: 'teams.contactUrl' });
  const isEmbedded = useSelector(getIsEmbedded);

  return (
    <Link href={contactUrl} target={isEmbedded ? '_self' : '_blank'}>
      {children}
    </Link>
  );
};

ContactLink.propTypes = {
  children: PropTypes.string,
};

export default ContactLink;
